import { useState } from "react";

import { fetchJSON } from "lib/fetch";
import siteConfig from "site-config";

import { TAPIResponse } from "../../types";
import { API_STATES } from "../../helpers";
import { EInviteBuyerType, EInvitationStatus } from "../types";

export type TCreateInvitationPayload = {
    merchantId: string;
    email: string;
    name: string;
    type: EInviteBuyerType;
};

export type TCreateInvitationError = { code: number; message: string };

export type TCreateInvitationResponse = {
    id: string;
    merchantId: string;
    email: string;
    name: string;
    type: EInviteBuyerType;
    createdOn: string;
    status: EInvitationStatus;
    expiresOn: string;
    createdBy: string;
    modifiedOn: string;
    archived: boolean;
};

type TCreateInvitationHookParams = {};

type TCreateInvitationHookResponse<Params, Response> = {
    (params?: Params): Response & {
        createInvitation: (params: TCreateInvitationPayload) => void;
    };
};

export const useCreateInvitation: TCreateInvitationHookResponse<
    TCreateInvitationHookParams,
    TAPIResponse<TCreateInvitationResponse, TCreateInvitationError>
> = (params: TCreateInvitationHookParams) => {
    const [state, setState] = useState<TAPIResponse<TCreateInvitationResponse, TCreateInvitationError>>(
        API_STATES.default,
    );
    const APIStates = API_STATES.getStates(setState);

    const createInvitation = (params: TCreateInvitationPayload) => {
        const URL = `${siteConfig.MERCHANT_ORGANIZATION_URL}/invitations.v1.Service/CreateInvitation`;

        APIStates.pending();

        fetchJSON<TCreateInvitationResponse>(URL, {
            method: "POST",
            body: JSON.stringify(params),
        })
            .then(APIStates.success)
            .catch((error) => APIStates.error({ message: error }));
    };

    return {
        data: state.data,
        error: state.error,
        isLoading: state.isLoading,
        loaded: state.loaded,
        createInvitation,
    };
};
